// extracted by mini-css-extract-plugin
module.exports = {"animationB":"animationB_animationB__lWFyF"};